import { css } from 'styled-components';
import token from 'styled-token';
import { StyledCheckbox } from '../../components/Checkbox/Checkbox.styles';
import { StyledTableCell } from '../../components/TableCell/TableCell.styles';
var hoverCSS = function hoverCSS(props) {
  var interactive = props.interactive;
  if (typeof interactive === 'undefined' || interactive === false) {
    return '';
  }
  return token('Table.rowBackgroundColorHover', function (backgroundColor) {
    return css(["&&:hover ", "{background-color:", ";}"], StyledTableCell, backgroundColor);
  })(props);
};
var selectedCSS = function selectedCSS(props) {
  var ariaSelected = props['aria-selected'];
  if (typeof ariaSelected === 'undefined' || ariaSelected === false) {
    return '';
  }
  return token('Table.rowBackgroundColorSelected', function (backgroundColor) {
    return css(["&&& ", "{background-color:", ";}"], StyledTableCell, backgroundColor);
  })(props);
};

/** @class TableRowMixin */
/** @method */
export var TableRowMixin = function TableRowMixin(props) {
  return css(["vertical-align:top;& ", "{vertical-align:text-top;}", " ", ""], StyledCheckbox, hoverCSS(props), selectedCSS(props));
};